import { IconType } from 'react-icons/lib';
import IconInfoCard from '../atoms/IconInfoCard';
import Button from '../atoms/Button';
import isMobile from '../../utils/isMobile';

interface EmptyTableProps {
  title: string;
  info: string;
  icon: IconType;
  iconColor: string;
  button?: {
    label: string;
    mobileLabel?: string;
    image?: string;
    imageInverted?: boolean;
    onClick: () => void;
    variant?: 'primary' | 'secondary' | 'tertiary';
    disabled?: boolean;
    icon?: IconType;
    reactIcon?: React.ReactNode;
    hidden?: boolean;
  }[];
}

const EmptyTable = ({
  title, info, icon, iconColor, button,
}: EmptyTableProps) => (
  <>
    {!button ? (
      <div className="flex flex-col items-center justify-center bg-surface-base shadow-sm rounded-3xl py-[40px] lg:py-[68px]">
        <div className="bg-surface-secondary p-4 items-center justify-center w-full py-20">
          <IconInfoCard
            title={title}
            info={info}
            icon={icon}
            iconColor={iconColor}
            className='shadow-none bg-surface-secondary border-none'
          />
        </div>
      </div>
    ) : (
      <div className="flex flex-col items-center justify-center bg-surface-base shadow-sm rounded-3xl pb-[40px] lg:pb-[68px]">
        <div className="flex items-center ml-auto p-4 lg:h-[68px]">
          <div className='flex flex-row gap-2'>
            {button?.filter((buttonItem) => !buttonItem?.hidden).map((buttonItem) => (
              <Button onClick={buttonItem?.onClick} variant={buttonItem?.variant} disabled={buttonItem?.disabled}>
                <div className="flex items-center justify-center p-2">
                  {buttonItem?.image && (
                    <img
                      src={buttonItem?.image}
                      alt={buttonItem?.label}
                      className={`min-w-[20px] min-h-[20px] w-5 h-5 ${buttonItem?.disabled ? 'opacity-50' : ''} ${buttonItem?.imageInverted ? 'invert' : ''}`}
                    />
                  )}
                  {buttonItem?.icon && (
                    <div className={`min-w-[20px] min-h-[20px] w-5 h-5 ${buttonItem?.disabled ? 'opacity-50' : ''}`}>
                      {buttonItem?.icon({ className: 'w-5 h-5' })}
                    </div>
                  )}
                  {buttonItem?.reactIcon && (
                    <div className={`min-w-[20px] min-h-[20px] w-5 h-5 ${buttonItem?.disabled ? 'opacity-50' : ''}`}>
                      {buttonItem?.reactIcon}
                    </div>
                  )}
                  <p className="whitespace-nowrap">
                    {isMobile() ? <div>{buttonItem?.mobileLabel}</div> : <div className='ml-2'>{buttonItem?.label}</div>}
                  </p>
                </div>
              </Button>
            ))}
          </div>
        </div>
        <div className="bg-surface-secondary p-4 items-center justify-center w-full py-20">
          <IconInfoCard
            title={title}
            info={info}
            icon={icon}
            iconColor={iconColor}
            className='shadow-none bg-surface-secondary border-none'
          />
        </div>
      </div>
    )}
  </>
);

export default EmptyTable;
